import { createNames } from "../../utils";
export const getAceLoaderNames = (id) => {
    return createNames(id, 'ACE-LOADER', '____ANIMATION_DISABLED', '____SIZE_XX_SMALL', '____SIZE_X_SMALL', '____SIZE_MEDIUM', '____FORCE_MODE_LIGHT', '____FORCE_MODE_DARK');
};
//# sourceMappingURL=ace-loader.get-names.js.map
